import React from "react";
import {Link} from "react-router-dom";
import WLogo from "../assets/QRscriptsWLogo.png";

const TermsOfUse = () => {
    return (
        <div className="w-full bg-white text-gray-900 min-h-screen">
            {/* ================= HEADER ================= */}
            <header className="w-full border-b bg-[#f6e9e4]">
                <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
                    <img src={WLogo} className="h-8" alt="QR Scripts" />

                    <nav className="hidden md:flex gap-6 text-sm font-medium text-gray-700">
                        <Link to="/">Home</Link>
                        <Link to="/privacypolicy">Privacy Policy</Link>
                        <Link to="/terms">Terms & Conditions</Link>
                    </nav>
                </div>
            </header>

            {/* ================= CONTENT ================= */}
            <section className="max-w-5xl mx-auto px-6 py-16">
                <h1 className="text-3xl md:text-4xl font-extrabold text-pink-600 mb-2">Terms of Use – QR Scripts</h1>

                <p className="text-sm text-gray-500 mb-10">
                    Effective Date: December 15, 2025 | Last Updated: December 15, 2025
                </p>

                <div className="space-y-10 text-sm leading-relaxed text-gray-700">
                    {/* 1 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">1. Acceptance of Terms</h2>
                        <p>
                            By scanning, registering, or using QR Scripts products and services, you agree to these
                            Terms of Use. If you do not agree, discontinue use immediately.
                        </p>
                    </section>

                    {/* 2 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">2. Service Description</h2>
                        <p>
                            QR Scripts provides programmable QR codes that redirect users to digital actions such as
                            websites, forms, contact details, or workflows.
                        </p>
                    </section>

                    {/* 3 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">3. User Registration</h2>
                        <p className="mb-2">Registration may require:</p>
                        <ul className="list-disc ml-6">
                            <li>Full name</li>
                            <li>Email address</li>
                            <li>QR code identifier</li>
                            <li>Destination URL or action</li>
                        </ul>
                        <p className="mt-2">Users are responsible for providing accurate and up-to-date information.</p>
                    </section>

                    {/* 4 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">4. Data Collection and Use</h2>

                        <h3 className="font-semibold mt-4">4.1 Information Collection</h3>
                        <p>
                            We collect registration data, scan analytics, IP addresses, device information, and usage
                            metrics.
                        </p>

                        <h3 className="font-semibold mt-4">4.2 Marketing Communications</h3>
                        <p>
                            By registering, you consent to receiving service notifications, updates, and promotional
                            communications from QR Scripts and Hourglass Essentials Pvt Ltd.
                        </p>

                        <h3 className="font-semibold mt-4">4.3 Public Visibility</h3>
                        <p>
                            Registered QR codes may display user-configured information when scanned by third parties.
                        </p>
                    </section>

                    {/* 5 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">5. Intellectual Property</h2>
                        <p>
                            All software, trademarks, QR systems, and platform content are the exclusive property of
                            Hourglass Essentials Pvt Ltd. Users receive a limited, revocable, non-transferable license.
                        </p>
                    </section>

                    {/* 6 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">6. User Responsibilities</h2>

                        <p className="font-semibold">Users must:</p>
                        <ul className="list-disc ml-6">
                            <li>Maintain accurate registration data</li>
                            <li>Use QR codes lawfully</li>
                            <li>Protect access credentials</li>
                        </ul>

                        <p className="font-semibold mt-4">Users must not:</p>
                        <ul className="list-disc ml-6">
                            <li>Use QR codes for illegal or misleading purposes</li>
                            <li>Distribute malicious links</li>
                            <li>Interfere with platform security</li>
                            <li>Resell QR services without authorization</li>
                        </ul>
                    </section>

                    {/* 7 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">7. Service Availability</h2>
                        <p>
                            Services are provided “as is” without uptime guarantees. QR Scripts may modify or
                            discontinue services at any time.
                        </p>
                    </section>

                    {/* 8 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">8. Limitation of Liability</h2>
                        <p>
                            QR Scripts is not liable for damages arising from misuse, service interruption, data
                            exposure, or third-party actions.
                        </p>
                        <p className="mt-2">Liability is limited to fees paid for the service, if any.</p>
                    </section>

                    {/* 9 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">9. Privacy and Security</h2>
                        <p>
                            Users acknowledge that QR scans may expose configured data publicly. Refer to the Privacy
                            Policy for full details.
                        </p>
                    </section>

                    {/* 10 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">10. Termination</h2>
                        <p>Accounts may be suspended or terminated for violations, misuse, or legal requirements.</p>
                    </section>

                    {/* 11 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">11. Modifications</h2>
                        <p>Terms may be updated periodically. Continued use indicates acceptance.</p>
                    </section>

                    {/* 12 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">12. Dispute Resolution</h2>
                        <p>Parties agree to attempt informal resolution before legal proceedings.</p>
                    </section>

                    {/* 13 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">13. Governing Law</h2>
                        <p>
                            These Terms are governed by the laws of India. Jurisdiction lies with courts in Bangalore.
                        </p>
                    </section>

                    {/* 14 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">14. Miscellaneous</h2>
                        <ul className="list-disc ml-6">
                            <li>Entire agreement</li>
                            <li>Severability</li>
                            <li>No waiver</li>
                            <li>Assignment restrictions</li>
                        </ul>
                    </section>

                    {/* 15 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">15. Contact Information</h2>
                        <p className="font-medium">QR Scripts – A Product of Hourglass Essentials Pvt Ltd</p>
                        <p>
                            #39 Krishna Reddy Colony, Domlur Layout,
                            <br />
                            Bangalore – 560071, India
                        </p>
                        <p>Email: itadmin@companystore.io</p>
                    </section>

                    {/* 16 */}
                    <section>
                        <h2 className="text-xl font-bold text-pink-600 mb-3">16. Acknowledgment</h2>
                        <p>
                            By using QR Scripts, you confirm that you have read, understood, and agreed to these Terms
                            of Use.
                        </p>
                    </section>

                    <p className="text-xs text-gray-500">
                        Document Version 1.0 | Governing Law: India | Jurisdiction: Bangalore
                    </p>
                </div>
            </section>

            {/* ================= FOOTER ================= */}
            <footer className="bg-gray-100 py-10">
                <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between text-sm text-gray-600">
                    <div>© {new Date().getFullYear()} QR Scripts</div>
                    <div className="flex gap-6">
                        <Link to="/privacypolicy">Privacy Policy</Link>
                        <Link to="/terms">Terms & Conditions</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default TermsOfUse;
